export const placeholderText =
  "We recommend at least 3 tags per Feels."

export const placeholderText2 =
  "Type your desired tag here and press return to create it. To delete a tag, click the 'X' on it."